/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import GetStartedAppModal from "./GetStartedAppModal.container";

export default GetStartedAppModal;
